import { render, staticRenderFns } from "./DocumentCell.vue?vue&type=template&id=61ec1008"
import script from "./DocumentCell.vue?vue&type=script&lang=js"
export * from "./DocumentCell.vue?vue&type=script&lang=js"
import style0 from "./DocumentCell.vue?vue&type=style&index=0&id=61ec1008&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports